class common {
    constructor(){

    }
    static  isNull(e) {
        if (
            e === null || e === "null" ||
            e === "" ||
            e === undefined ||
            e === "undefined" ||
            e === [] ||
            e.length === 0
        ) {
            return true;
        } else {
            return false;
        }
    }

}





export default common


// WEBPACK FOOTER //
// ./src/modules/common.js